export default __webpack_public_path__ + "78bdb5a.png";